<app-mb-card class="info-card" [formGroup]="newLicenseForm">
  <header>
    <h3>Añadir datos para una nueva licencia</h3>
  </header>
  <footer>
    <div class="section-heading">
      <label class="active-toggle">
        <span>Activo</span>
        <input type="checkbox" formControlName="active" autocomplete="new-password">
      </label>
    </div>
    <div class="form-grid basic-grid">
      <app-mb-field [title]="'Compañía *'" fullwidth>
        <select formControlName="licenseCompany">
          <option [ngValue]="null">Elige una compañía</option>
          @for (company of companies; track company) {
            <option [ngValue]="company">{{ company.companyName }}</option>
          }
        </select>
        @if (hasError('licenseCompany')) {
          <h6 translate>
          {{ hasError('licenseCompany') === 'required' ? 'required' : hasError('licenseCompany')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Nombre *'" fullwidth>
        <input type="text" placeholder="Ej.: Licencia" formControlName="licenseDescription"
          autocomplete="new-text">
        @if (hasError('licenseDescription')) {
          <h6 translate>
            {{ hasError('licenseDescription') === 'required' ? 'required' : hasError('licenseDescription')}}
          </h6>
        }
      </app-mb-field>
      @if (selectedCompany) {
        <app-mb-field [title]="'Email'" fullwidth>
          <input type="email" placeholder="Ej.: licencia@empresa.com" formControlName="licenseEmail"
            autocomplete="new-email">
        </app-mb-field>
        <app-mb-field [title]="'Documento'" fullwidth>
          <input type="text" placeholder="Ej.: CIF/NIF/Pasaporte" formControlName="licenseDocument"
            autocomplete="new-text">
        </app-mb-field>
      }
    </div>
    @if (selectedCompany) {
      <div class="form-grid assignment-grid">
        <app-mb-field class="toggle-field" [title]="'Multi Center'">
          <input type="checkbox" formControlName="licenseMultiCenter" autocomplete="new-password" (change)="toggleMultiCenter()">
        </app-mb-field>
        <app-mb-field [title]="'Centro'" fullwidth>
          <select formControlName="licenseCenter">
            <option [ngValue]="null">Elige un centro</option>
            @for (center of centers; track center) {
              <option [ngValue]="center">{{ center.centerName }}</option>
            }
          </select>
        </app-mb-field>
        <app-mb-field class="toggle-field" [title]="'Multi App'">
          <input type="checkbox" formControlName="licenseMultiApp" autocomplete="new-password" (change)="toggleMultiApp()">
        </app-mb-field>
        <app-mb-field [title]="'Aplicación'" fullwidth>
          <select formControlName="licenseApplication">
            <option [ngValue]="null">Elige una aplicación</option>
            @for (application of applications; track application) {
              <option [ngValue]="application">{{ application.applicationName }}</option>
            }
          </select>
        </app-mb-field>
      </div>
    }
    @if (selectedCompany) {
      <div class="form-grid validity-grid">
        <app-mb-field [title]="'Cantidad *'" fullwidth>
          <input type="number" placeholder="Ej.: 100" formControlName="licenseQuantity"
            autocomplete="new-text">
          @if (hasError('licenseQuantity')) {
            <h6 translate>
              {{ hasError('licenseQuantity') === 'required' ? 'required' : hasError('licenseQuantity')}}
            </h6>
          }
        </app-mb-field>
        <app-mb-field [title]="'Fecha inicio *'" [preicon]="true" [posticon]="true" fullwidth>
          <i class="far fa-calendar"></i>
          <i class="fas fa-times" (click)="clearField('licenseStartDateMillis')"></i>
          <input matInput [matDatepicker]="dateFromPicker" formControlName="licenseStartDateMillis" placeholder="Seleccione fecha"
            (click)="dateFromPicker.open()" format="24" formatDate="'DD-MM-YYYY'" readonly>
          <mat-datepicker #dateFromPicker></mat-datepicker>
          @if (hasError('licenseStartDateMillis')) {
            <h6 translate>
              {{ hasError('licenseStartDateMillis') === 'required' ? 'required' : hasError('licenseStartDateMillis')}}
            </h6>
          }
        </app-mb-field>
        <app-mb-field [title]="'Fecha fin *'" [preicon]="true" [posticon]="true" fullwidth>
          <i class="far fa-calendar"></i>
          <i class="fas fa-times" (click)="clearField('licenseEndDateMillis')"></i>
          <input matInput [matDatepicker]="dateToPicker" formControlName="licenseEndDateMillis" placeholder="Seleccione fecha"
            (click)="dateToPicker.open()" format="24" formatDate="'DD-MM-YYYY'" readonly>
          <mat-datepicker #dateToPicker></mat-datepicker>
          @if (hasError('licenseEndDateMillis')) {
            <h6 translate>
              {{ hasError('licenseEndDateMillis') === 'required' ? 'required' : hasError('licenseEndDateMillis')}}
            </h6>
          }
        </app-mb-field>
      </div>
    }
    @if (licenseCreationFormErrorMessage) {
      <h6>{{ licenseCreationFormErrorMessage }}</h6>
    }
    <div class="form-actions">
      @if (!createdLicense && selectedCompany) {
        <app-mb-button (click)="addNewLicense()">Crear</app-mb-button>
      }
      @if (createdLicense) {
        <app-mb-button [routerLink]="['/licenses']">Volver al listado</app-mb-button>
      }
      @if (createdLicense) {
        <app-mb-button [routerLink]="['/license', createdLicense?.internalId]">Ver licencia creada</app-mb-button>
      }
    </div>
  </footer>
</app-mb-card>
